import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetBitcoinDisplayPreferenceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetBitcoinDisplayPreferenceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setBitcoinDisplayPreference = (
  request: SetBitcoinDisplayPreferenceRequest,
  options?: CashRequestOptions
) =>
  post<SetBitcoinDisplayPreferenceRequest, SetBitcoinDisplayPreferenceResponse>(
    '/2.0/cash/set-bitcoin-display-preference',
    request,
    { ...options, rejectOnError: true }
  )
